export default "__VITE_PUBLIC_ASSET__50e20101__"